import type { IconSvgObject } from './types';

const VibrateIcon: IconSvgObject = [
  ["path", { d: "M15.5 4H8.5C7.67157 4 7 4.67157 7 5.5V18.5C7 19.3284 7.67157 20 8.5 20H15.5C16.3284 20 17 19.3284 17 18.5V5.5C17 4.67157 16.3284 4 15.5 4Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 8L20 10L22 12L20 14L22 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 8L4 10L2 12L4 14L2 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default VibrateIcon;
